import { RatesOption } from 'app/constants/ratesOption'

export const getRatesOptionName = (
  type: RatesOption,
  translate: (string) => string,
): string => {
  const text: string = RatesOption[type]
  return translate(`ratesOption.${text}`)
}
